import React, { Component } from 'react'

class Input extends Component {
  focus() {
    this.input.focus()
  }

  onClear(e) {
    e.preventDefault()
    e.stopPropagation()
    const { onClear } = this.props
    onClear(e)
  }

  render() {
    const { onFocus, onBlur, placeholder, value, onClick } = this.props
    return (
      <div style={{ position: 'relative' }}>
        {this.props.value ? (
          <svg
            onClick={e => this.onClear(e)}
            style={{
              cursor: 'pointer',
              position: 'absolute',
              right: 3,
              top: 4
            }}
            fill={'rgba(0,0,0,0.57)'}
            height={10}
            viewBox={'0 0 24 24'}
            width={10}
          >
            <path
              d={
                'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
              }
            />
            <path d={'M0 0h24v24H0z'} fill={'none'} />
          </svg>
        ) : null}

        <input
          ref={el => (this.input = el)}
          type={'text'}
          onFocus={onFocus}
          onClick={onClick}
          onBlur={onBlur}
          placeholder={placeholder}
          value={value}
          style={{ width: 101, borderRadius: 2, border: '1px solid #ccc' }}
          readOnly={'readonly'}
        />
      </div>
    )
  }
}

export default Input



// WEBPACK FOOTER //
// ./src/components/Node/Calendar/input.js